import { combineReducers } from 'redux'
import FormManagementFormListSlice from '../../slices/experiences/FormManagementFormListSlice'

const FormManagementExperienceStore = combineReducers({
  list: FormManagementFormListSlice.reducer
})

export default FormManagementExperienceStore
